"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tapis Applications API
 * The Tapis Applications API provides for management of Tapis applications including permissions.
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @export
 * @enum {string}
 */
var ArgInputModeEnum;
(function (ArgInputModeEnum) {
    ArgInputModeEnum["Required"] = "REQUIRED";
    ArgInputModeEnum["Fixed"] = "FIXED";
    ArgInputModeEnum["IncludeOnDemand"] = "INCLUDE_ON_DEMAND";
    ArgInputModeEnum["IncludeByDefault"] = "INCLUDE_BY_DEFAULT";
})(ArgInputModeEnum = exports.ArgInputModeEnum || (exports.ArgInputModeEnum = {}));
function ArgInputModeEnumFromJSON(json) {
    return ArgInputModeEnumFromJSONTyped(json, false);
}
exports.ArgInputModeEnumFromJSON = ArgInputModeEnumFromJSON;
function ArgInputModeEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ArgInputModeEnumFromJSONTyped = ArgInputModeEnumFromJSONTyped;
function ArgInputModeEnumToJSON(value) {
    return value;
}
exports.ArgInputModeEnumToJSON = ArgInputModeEnumToJSON;
